// i18n
import './locales/i18n';

// scroll bar
import 'simplebar/src/simplebar.css';

// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';

// ----------------------------------------------------------------------

import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from '@azure/msal-browser';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// locales
import ThemeLocalization from './locales';
// components
import SnackbarProvider from './components/snackbar';
import { ThemeSettings, SettingsProvider } from './components/settings';
import { MotionLazyContainer } from './components/animate';
import ScrollToTop from './components/scroll-to-top';

// Check our docs
// https://docs.minimals.cc/authentication/js-version

import { AuthProvider } from './auth/JwtContext';

// ----------------------------------------------------------------------

export default function App() {
  const pubClientApp = new PublicClientApplication({
    auth: {
      clientId:  process.env.REACT_APP_ClientId, 
      authority: process.env.REACT_APP_authority,
      redirectUri: process.env.REACT_APP_redirectUri,
      postLogoutRedirectUri:process.env.REACT_APP_postLogoutRedirectUri,
      navigateToLoginRequestUrl:process.env.REACT_APP_navigateToLoginRequestUrl
    },
  });
  return (
    // <AuthProvider>
    //   <HelmetProvider>
    //     <SettingsProvider>
    //       <BrowserRouter>
    //         <ScrollToTop />
    //         <MotionLazyContainer>
    //           <ThemeProvider>
    //             <ThemeSettings>
    //               <ThemeLocalization>
    //                 <SnackbarProvider>
    //                   <Router />
    //                 </SnackbarProvider>
    //               </ThemeLocalization>
    //             </ThemeSettings>
    //           </ThemeProvider>
    //         </MotionLazyContainer>
    //       </BrowserRouter>
    //     </SettingsProvider>
    //   </HelmetProvider>
    // </AuthProvider>
    <MsalProvider instance={pubClientApp}>
      <AuthProvider>
        <HelmetProvider>
          <SettingsProvider>
            <BrowserRouter>
              <ScrollToTop />
              <MotionLazyContainer>
                <ThemeProvider>
                  <ThemeSettings>
                    <ThemeLocalization>
                      <SnackbarProvider>
                        <Router />
                      </SnackbarProvider>
                    </ThemeLocalization>
                  </ThemeSettings>
                </ThemeProvider>
              </MotionLazyContainer>
            </BrowserRouter>
          </SettingsProvider>
        </HelmetProvider>
      </AuthProvider>
    </MsalProvider>
  );
}
